function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1026.722 -1244.235)"
}, React.createElement("g", {
  transform: "translate(1462.5 592.11)"
}, React.createElement("path", {
  d: "M-381.31,722.142a5.061,5.061,0,0,1-3.17-.744,3.465,3.465,0,0,1-.911-2.779,14.806,14.806,0,0,1,.276-2.386c.206-1.046.411-2,.654-2.817l2.889-10.234a16.121,16.121,0,0,0,.577-3.1c.1-1.117.153-1.9.153-2.348a6.712,6.712,0,0,0-2.277-5.256,9.372,9.372,0,0,0-6.449-2.034,15.942,15.942,0,0,0-4.927.841c-1.733.558-3.561,1.212-5.461,1.995l-.764,3.151c.559-.206,1.227-.43,2.01-.673a8.465,8.465,0,0,1,2.315-.335,4.539,4.539,0,0,1,3.094.764,3.714,3.714,0,0,1,.821,2.74,12.951,12.951,0,0,1-.263,2.425c-.167.86-.391,1.79-.649,2.778L-396.3,714.4a29.19,29.19,0,0,0-.558,2.893,19.786,19.786,0,0,0-.168,2.516,6.6,6.6,0,0,0,2.33,5.222,9.56,9.56,0,0,0,6.564,2.072,14.448,14.448,0,0,0,4.812-.73q2.068-.723,5.556-2.086l.783-3.17a13.815,13.815,0,0,1-1.938.649A9.156,9.156,0,0,1-381.31,722.142Z"
}), React.createElement("path", {
  d: "M-383.157,671.723a7.018,7.018,0,0,0-4.884,1.881,6.1,6.1,0,0,0-2.033,4.573,6.039,6.039,0,0,0,2.033,4.568,7.013,7.013,0,0,0,4.884,1.881,6.983,6.983,0,0,0,4.888-1.881,6.02,6.02,0,0,0,2.014-4.568,6.083,6.083,0,0,0-2.014-4.573A6.988,6.988,0,0,0-383.157,671.723Z"
})), React.createElement("path", {
  d: "M-388.5,746.706a47.345,47.345,0,0,1-47.28-47.3,47.333,47.333,0,0,1,47.28-47.279A47.343,47.343,0,0,1-341.2,699.4,47.355,47.355,0,0,1-388.5,746.706Zm0-86a38.746,38.746,0,0,0-38.7,38.7,38.757,38.757,0,0,0,38.7,38.724A38.768,38.768,0,0,0-349.774,699.4,38.757,38.757,0,0,0-388.5,660.7Z",
  transform: "translate(1462.5 592.11)"
}));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 94.581,
    height: 94.581,
    viewBox: "0 0 94.581 94.581",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info_icon.4013872d.svg";
export { ForwardRef as ReactComponent };